import Ethos_Myyja from '../../../../../images/svg/Ethos_Myyja.svg'
import Ethos_Vastaaja from '../../../../../images/svg/Ethos_Vastaaja.svg'

import Pathos_Myyja from '../../../../../images/svg/Pathos_Myyja.svg'
import Pathos_Vastaaja from '../../../../../images/svg/Pathos_Vastaaja.svg'

import Logos_Myyja from '../../../../../images/svg/Logos_Myyja.svg'
import Logos_Vastaaja from '../../../../../images/svg/Logos_Vastaaja.svg'

import { animated } from 'react-spring'

const SelectorButton = (
    { selector, style, role, onClick,
        springStyle, springLogoStyle, disabled }) => {

    const getButtonType = () => {
        switch (selector.type) {
            case 'ETHOS':
                if (role === 'seller') {
                    return Ethos_Myyja
                }
                return Ethos_Vastaaja
            case 'PATHOS':
                if (role === 'seller') {
                    return Pathos_Myyja
                }
                return Pathos_Vastaaja
            case 'LOGOS':
                if (role === 'seller') {
                    return Logos_Myyja
                }
                return Logos_Vastaaja
            default:
                return ''

        }
    }

    return (
        <div className='selector-button-container'
            onClick={() => onClick(selector.type)}>
            <animated.img style={springLogoStyle}
                src={getButtonType()} alt={selector.type} className={`selector-logo${disabled ? '-disabled' : ''}`} />
            <div className='button-container-container'>
                <animated.div className={`${style} selector-button-general`}
                    style={springStyle}>
                    {selector.text}
                </animated.div>
            </div>

        </div>
    )
}

export default SelectorButton